import {Base} from "@/api/Base"

export class RemainingVacationAdd extends Base {
    path = "remainingVacation/add"
}